import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import camelCaseRecursive from 'camelcase-keys-recursive';

import JointCommitteeInfo from './JointCommitteeInfo';
import { LinkBtn, Icon } from '../../../components';
import { showJointCommitteeRequest } from '../../../requests/jointCommittees';

class JointCommitteeShow extends Component {
  state = {
    jointCommittee: {
      address: '',
      addressNumber: '',
      code: '',
      employeeJointCommitteesAttributes: [],
      name: '',
      phone: ''
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const { match, dispatch } = this.props;
    const jointCommitteeId = match.params.id;
    showJointCommitteeRequest(jointCommitteeId, {
      dispatch,
      successCallback: response => this.handleSuccessShow(response)
    });
  }

  handleSuccessShow = response => {
    const jointCommittee = camelCaseRecursive(response.data);
    this.setState({ jointCommittee });
  };

  render() {
    const { jointCommittee } = this.state;
    return (
      <>
        <Row className="mt-4 mb-4">
          <Col md={1}>
            <LinkBtn variant="circle-dark" className="btn-circle" block to="/profile/groupings?tab=joint-committees">
              <Icon icon="chevron-back" />
            </LinkBtn>
          </Col>
          <Col />
        </Row>
        <JointCommitteeInfo jointCommittee={jointCommittee} />
      </>
    );
  }
}

export default connect()(JointCommitteeShow);
